import { render, staticRenderFns } from "./ShippingData.vue?vue&type=template&id=433d4e14&lang=pug"
import script from "./ShippingData.vue?vue&type=script&lang=js"
export * from "./ShippingData.vue?vue&type=script&lang=js"
import style0 from "./ShippingData.vue?vue&type=style&index=0&id=433d4e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports